import {Service} from "@/services/superclasses/service";
import {IdName} from "@/interfaces/superclasses/id-name";

const api = window.contextPath + '/rest/watch-notification-types';

export class WatchNotificationTypeService extends Service {

    constructor() {
        super()
    }

    public search = async (): Promise<IdName[]> => {
        return this.data(await this.get<IdName[]>(api))
    };
}

export const watchNotificationTypeService = new WatchNotificationTypeService()
